export const TIMER_CONSTS = {
  DOCUMENT_CENTER_INTERVAL: 30000,
  LOGIN_SEESION_CHECK_INTERVAL: 20000, //10000,
  AUTO_LOGOUT_CONFIRMATION_WINDOW: 20000,
};
